import { useRecoilCallback } from 'recoil';
import { DICOMApprovalStatus } from '~/domain/dicom/dicomConstants';
import { structureSetReadModelFamily } from '~/state/atoms/structureSet/structureSetAtoms';

/**
 * Returns a callback that snapshots a structure set's approval status by
 * SOP Instance UID at call time. Connector workflow hooks call this at
 * submit so the value can be frozen on the Job — the job card then
 * reflects the input as it was when the user clicked Submit, regardless
 * of later approval changes. Resolves to undefined when the UID is absent
 * or the set is not loaded.
 */
export function useSnapshotInputApprovalStatus(): (
    structureSetUid: string | undefined
) => Promise<DICOMApprovalStatus | undefined> {
    return useRecoilCallback(
        ({ snapshot }) =>
            async (structureSetUid: string | undefined) => {
                if (!structureSetUid) {
                    return undefined;
                }
                const readModel = await snapshot.getPromise(
                    structureSetReadModelFamily(structureSetUid)
                );
                return readModel?.approvalStatus;
            },
        []
    );
}
